import React from 'react';
import {
  FilePdfOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileImageOutlined,
  FileTextOutlined,
} from '@ant-design/icons';

export interface FileKind {
  icon: React.ReactNode;
  color: string;
  soft: string;
  label: string;
}

/** Icon + colour by file extension, so documents are recognisable at a glance.
 *  Mirrors the mobile helper (components/admin/fileKind.ts). */
export const fileKind = (fileName: string): FileKind => {
  const extension = fileName.split('?')[0].split('.').pop()?.toLowerCase() ?? '';

  if (extension === 'pdf') {
    return { icon: <FilePdfOutlined />, color: '#DC2626', soft: '#FEE2E2', label: 'PDF' };
  }
  if (['doc', 'docx'].includes(extension)) {
    return { icon: <FileWordOutlined />, color: '#2563EB', soft: '#DBEAFE', label: 'DOC' };
  }
  if (['xls', 'xlsx', 'csv'].includes(extension)) {
    return { icon: <FileExcelOutlined />, color: '#16A34A', soft: '#DCFCE7', label: 'XLS' };
  }
  if (['ppt', 'pptx'].includes(extension)) {
    return { icon: <FilePptOutlined />, color: '#EA580C', soft: '#FFEDD5', label: 'PPT' };
  }
  if (['jpg', 'jpeg', 'png', 'webp', 'heic', 'gif'].includes(extension)) {
    return { icon: <FileImageOutlined />, color: '#7C3AED', soft: '#EDE9FE', label: extension.toUpperCase() };
  }

  return {
    icon: <FileTextOutlined />,
    color: 'var(--e22-primary)',
    soft: 'var(--e22-primary-soft)',
    label: extension.toUpperCase() || 'FILE',
  };
};
